import { render, staticRenderFns } from "./AddUpdateFood.vue?vue&type=template&id=5227db5f&scoped=true"
import script from "./AddUpdateFood.vue?vue&type=script&lang=js"
export * from "./AddUpdateFood.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateFood.vue?vue&type=style&index=0&id=5227db5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227db5f",
  null
  
)

export default component.exports